import { render } from "./TryModelPage.vue?vue&type=template&id=10438a0c&scoped=true"
import script from "./TryModelPage.vue?vue&type=script&lang=js"
export * from "./TryModelPage.vue?vue&type=script&lang=js"

import "./TryModelPage.vue?vue&type=style&index=0&id=10438a0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10438a0c"]])

export default __exports__